const APPROVED_STATUSES = new Set(['approved', 'valid', 'validated']);

export const normalizeArtisanRegistrationStatus = (status) => {
  const normalized = String(status || 'pending').trim().toLowerCase();
  if (APPROVED_STATUSES.has(normalized)) return 'approved';
  if (['rejected', 'declined', 'refused'].includes(normalized)) return 'rejected';
  if (['suspended', 'blocked', 'disabled'].includes(normalized)) return 'suspended';
  return 'pending';
};

export const isArtisanApproved = (status) => (
  normalizeArtisanRegistrationStatus(status) === 'approved'
);

const STATUS_LABELS = {
  fr: {
    approved: 'Profil validé',
    rejected: 'Validation refusée',
    suspended: 'Profil suspendu',
    pending: 'Validation en cours',
  },
  en: {
    approved: 'Verified profile',
    rejected: 'Verification declined',
    suspended: 'Profile suspended',
    pending: 'Verification in progress',
  },
};

const STATUS_MESSAGES = {
  fr: {
    approved: 'Votre profil est validé. Vous pouvez envoyer des propositions aux clients.',
    rejected: 'Votre profil n’a pas été validé. Vérifiez vos informations et contactez l’assistance.',
    suspended: 'Votre profil est temporairement suspendu. Contactez l’assistance avant de répondre aux demandes.',
    pending: 'Vous pouvez parcourir les demandes pendant la vérification. L’envoi de propositions sera activé après validation de votre profil.',
  },
  en: {
    approved: 'Your profile is verified. You can send proposals to clients.',
    rejected: 'Your profile was not verified. Review your information and contact support.',
    suspended: 'Your profile is temporarily suspended. Contact support before replying to requests.',
    pending: 'You can browse requests while verification is in progress. Proposal submission will be enabled once your profile is verified.',
  },
};

export const artisanRegistrationLabel = (status, language = 'fr') => {
  const locale = language === 'en' ? 'en' : 'fr';
  return STATUS_LABELS[locale][normalizeArtisanRegistrationStatus(status)];
};

export const artisanRegistrationMessage = (status, language = 'fr') => {
  const locale = language === 'en' ? 'en' : 'fr';
  return STATUS_MESSAGES[locale][normalizeArtisanRegistrationStatus(status)];
};
